import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import LandingPageIndex from "./LandingPageIndex";

export default function MainLandingPage({ title }) {
  const [modalShow, setModalShow] = useState("welcome");

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <>
      <LandingPageIndex
        title={title}
        setModalShow={setModalShow}
        fullScreen={fullScreen}
        modalShow={modalShow}
      />
    </>
  );
}
